module.exports = __webpack_public_path__ + "static/media/CloseMenuButton.1c173f5f.svg";